import { BrowserRouter } from 'react-router-dom';
import AddPaymentContainer, {
  AddPaymentContainerProps,
} from './addPaymentContainer';

const AddPaymentRouter = (props: AddPaymentContainerProps) => {
  return (
    <BrowserRouter basename="/add-payment/">
      <AddPaymentContainer {...props} />
    </BrowserRouter>
  );
};

export default AddPaymentRouter;
